import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-773f9844"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "avatar-wrapper"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "columns is-align-items-center"
};
var _hoisted_4 = {
  class: "column is-narrow"
};
var _hoisted_5 = {
  class: "column"
};
var _hoisted_6 = {
  class: "avatar-wrapper--name"
};
var _hoisted_7 = {
  class: "has-text-weight-bold"
};
var _hoisted_8 = {
  class: "has-text-grey"
};
var _hoisted_9 = {
  class: "has-text-grey-light"
};
var _hoisted_10 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_avatar = _resolveComponent("el-avatar");

  return _ctx.avatarWithLink ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_avatar, null, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.getInitials), 1)];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getFullName), 1), _createElementVNode("span", _hoisted_8, " - " + _toDisplayString(_ctx.getRoleName), 1)]), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.getEmail), 1), _renderSlot(_ctx.$slots, "default", {}, undefined, true)])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_avatar, null, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.getInitials), 1)];
    }),
    _: 1
  }), _createElementVNode("span", null, _toDisplayString(_ctx.getFullName), 1)]));
}